/** Etiquetas i18n del CRM (F3-I). Mapean las keys estables del backend a texto. */
import { msg } from "@lingui/core/macro";
import type { MessageDescriptor } from "@lingui/core";
import type { Source, Stage } from "./api";

export const STAGE_LABEL: Record<Stage, MessageDescriptor> = {
  nuevo: msg`New`,
  contactado: msg`Contacted`,
  visita: msg`Visit`,
  inscrito: msg`Enrolled`,
  perdido: msg`Lost`,
};

export const SOURCE_LABEL: Record<Source, MessageDescriptor> = {
  landing: msg`Landing`,
  walk_in: msg`Walk-in`,
  referral: msg`Referral`,
  instagram: msg`Instagram`,
  whatsapp: msg`WhatsApp`,
  other: msg`Other`,
};

const FIELD_LABEL: Record<string, MessageDescriptor> = {
  stage: msg`Stage`,
  source: msg`Source`,
  assigned_to: msg`Assigned to`,
  interest_course_id: msg`Course of interest`,
  interest: msg`Interest (text)`,
  created_days_ago: msg`Created (days ago)`,
  debt_usd_minor: msg`Debt (USD minor)`,
  last_active_days: msg`Inactive (days)`,
  cohort_status: msg`Cohort status`,
  national_id: msg`National ID`,
  campus_id: msg`Campus`,
};

const OP_LABEL: Record<string, MessageDescriptor> = {
  eq: msg`is`,
  neq: msg`is not`,
  gt: msg`greater than`,
  lt: msg`less than`,
  contains: msg`contains`,
  in: msg`in`,
};

const EVENT_LABEL: Record<string, MessageDescriptor> = {
  note: msg`Note`,
  call: msg`Call`,
  whatsapp: msg`WhatsApp`,
  email: msg`Email`,
  visit: msg`Visit`,
  stage_change: msg`Stage change`,
  created: msg`Created`,
};

// Accesores seguros: los mapas se indexan por `string`, así que devuelven un
// descriptor definido con respaldo (evita `MessageDescriptor | undefined`).
const FALLBACK: MessageDescriptor = msg`—`;
export const fieldLabel = (f: string): MessageDescriptor => FIELD_LABEL[f] ?? FALLBACK;
export const opLabel = (o: string): MessageDescriptor => OP_LABEL[o] ?? FALLBACK;
export const eventLabel = (k: string): MessageDescriptor => EVENT_LABEL[k] ?? FALLBACK;
